module.exports = {
  iconCloseLargeData: "data:image/svg+xml,%3csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.613.21l.094.083L10 8.585 18.293.293a1 1 0 011.497 1.32l-.083.094L11.415 10l8.292 8.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.083l-.094-.083L10 11.415l-8.293 8.292a1 1 0 01-1.497-1.32l.083-.094L8.585 10 .293 1.707A1 1 0 01.21.387L.293.293A1 1 0 011.613.21z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconCloseLargeWidth: 20,
  iconCloseLargeHeight: 20
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@meridian/tokens/base/icon/close-large.js
// module id = 390
// module chunks = 7